<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter"><strong class="b"><em class="i">“You do not like me much, little one, do you?”</em></strong></div>
<div class="p"><span>Kit decided silence was definitely the best policy. There was nothing she could say.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“I am clearly the lesser of two evils, and it is a long time since I have been cast in such a rôle—” Gerard’s glittering gold eyes moved swiftly over her “—especially by such a beautiful woman.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“You said you didn’t find me attractive.. ”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>The deep voice was unrepentant “I lied!”</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459253025_fm01.vue?7bb24f9f